export const BUSINESS_TYPE_VALUES = {
  BUSINESS: 'business',
  FREELANCER: 'freelancer',
  AGENCY: 'agency',
  ENTERPRISE: 'enterprise',
}